import { useCallback, useEffect, useRef } from "react";
import {MINUTE_TIMER_TIMEOUT} from "src/utils/Constants";

type UseIdleTimer = (
  timeout: number,
  onIdle: () => void,
  onWarning: () => void,
  isSessionTimedOut: boolean,
) => () => void;

export const useIdleTimer: UseIdleTimer = (
  onIdle,
  onWarning,
  isSessionTimedOut,
  timeout = MINUTE_TIMER_TIMEOUT,
) => {
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const warningTimeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const resetTimer = useCallback(() => {
    if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
    if (warningTimeoutIdRef.current) clearTimeout(warningTimeoutIdRef.current);

    if (isSessionTimedOut) {
      warningTimeoutIdRef.current = setTimeout(onWarning, timeout - 23000);

      timeoutIdRef.current = setTimeout(onIdle, timeout);
    }
  }, [onWarning, onIdle, timeout, isSessionTimedOut]);
  useEffect(() => {
    if (isSessionTimedOut) {
      resetTimer();
    }
    const events = ["click"];
    const handleEvent = () => resetTimer();

    events.forEach((event) => window.addEventListener(event, handleEvent));

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleEvent));
      if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
      if (warningTimeoutIdRef.current)
        clearTimeout(warningTimeoutIdRef.current);
    };
  }, [resetTimer, isSessionTimedOut]);
  return resetTimer;
};
